import apiClient from '../apiClient';
import { HomeQCardsResponse } from '../types/listings';

export const getListings = () => {
  return apiClient.get<HomeQCardsResponse>('/listings');
};
